<section class="contact-area ptb-100">
    <div class="container">
        <div class="section-title">
            <h2>Contact Us</h2>
            <div class="bar"></div>
            <br>
        </div>

        <div class="row">
            <!-- Contact Form -->
            <div class="col-lg-6 mb-4">
                <div class="contact-form-container p-4 p-md-5" style="
                    background-color: #ffffff;
                    border: 1px solid #ddd;
                    border-radius: 15px;
                    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);">
                    <h3 class="mb-4 text-center">Get in Touch</h3>
                    <form id="contactForm" action="https://formsubmit.co/admin@mupo0108.co.za" method="POST">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <input type="text" name="name" id="name" class="form-control" required placeholder="Your Name">
                            </div>
                            <div class="col-md-6 mb-3">
                                <input type="email" name="email" id="email" class="form-control" required placeholder="Your Email">
                            </div>
                            <div class="col-md-6 mb-3">
                                <input type="text" name="phone_number" id="phone_number" class="form-control" required placeholder="Your Phone">
                            </div>
                            <div class="col-md-6 mb-3">
                                <input type="text" name="msg_subject" id="msg_subject" class="form-control" required placeholder="Subject">
                            </div>
                            <div class="col-12 mb-4">
                                <textarea name="message" class="form-control" id="message" rows="5" required placeholder="Your Message"></textarea>
                            </div>
                            <div class="col-12 text-center">
                                <button type="submit" class="btn btn-primary px-5 py-2" >Submit</button>
                            <input type="hidden" name="_captcha" value="false">
                            <input type="text" name="_honey" style="display:none">
                            <input type="hidden" name="_next" value="https://dotblack.co.za">

                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <!-- Contact Info -->
            <div class="col-lg-6 mb-4">
                <div class="contact-form-container d-flex justify-content-center align-items-center flex-column p-4 p-md-5 " style="
                    background-color: #ffffff;
                    border: 1px solid #ddd;
                    border-radius: 15px;
                    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);">
                    <h3 class="mb-4 text-center"  >Contact Information</h3><br>
                    <p><i class="fa fa-phone mr-2  " style="font-size: 18px; "></i><a href="tel:+27115685421"> +27 11 568 5421</a></p>
                    <p><i class="fa fa-envelope mr-2 " style="font-size: 18px;"></i><a href="mailto:mufk@dotblack.co.za"> mufk@dotblack.co.za</a></p>
                <div style="text-align: center;">
                 <i class="fa fa-map-marker" style="font-size: 18px; display: block; margin-bottom: 8px;"></i> Jardown 1, Office 0005,<br>
                 377 Johannes Ramokhoase Street,<br>
                 Pretoria Central,<br>
                 0002
               </div>

                <br><br><br>
<!--                        <h2>-->
<!--                            <i class="fa fa-phone" style="font-size: 23px"> &nbsp;&nbsp;</i>-->
<!--                            <a href="tel:+27 11 568 5421">+27 11 568 5421</a>-->
<!--                            <span></span>-->
<!--                            <i class="fa fa-envelope" style="font-size: 23px"> &nbsp;&nbsp; </i>-->
<!--                            <a href="mailto:mufk@dotblack.co.za">mufk@dotblack.co.za</a>-->
<!--                            -->
<!--&lt;!&ndash;                            <h5>61 Katherine Street&ndash;&gt;-->
<!--&lt;!&ndash;                            </h5>&ndash;&gt;-->
<!--&lt;!&ndash;                            <h5>Sandton&ndash;&gt;-->
<!--&lt;!&ndash;                            </h5>&ndash;&gt;-->
<!--&lt;!&ndash;                            <h5>1st Floor Office 321&ndash;&gt;-->
<!--&lt;!&ndash;                            </h5>&ndash;&gt;-->
<!--                        </h2>-->

<!--                        <h5>61 Katherine Street-->
<!--                        </h5>-->
<!--                        <h5>Sandton-->
<!--                        </h5>-->
<!--                        <h5>1st Floor Office 321-->
<!--                        </h5>-->
<!--                        <ul class="social">-->
<!--                            <li><a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a></li>-->
<!--                            <li><a href="#" target="_blank"><i class="fab fa-twitter"></i></a></li>-->
<!--                            <li><a href="#" target="_blank"><i class="fab fa-linkedin-in"></i></a></li>-->
<!--                            <li><a href="#" target="_blank"><i class="fab fa-instagram"></i></a></li>-->
<!--                        </ul>-->
                    
                </div>
            </div>
        </div>
    </div>

    <br>
    <div class="container-fluid" style="padding: 5rem;">
        <div class="row shadow-lg">
            <div class="col-lg-12 col-md-12">
                
                <iframe width="100%" height="600" frameborder="0" scrolling="no" referrerpolicy="no-referrer-when-downgrade" marginheight="0" marginwidth="0"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3593.820801396512!2d28.1965088!3d-25.743438999999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e9562052e5f80ed%3
                A0xca60731e962eb474!2s377%20Johannes%20Ramokhoase%20St%2C%20Pretoria%20Central%2C%20Pretoria%2C%200002!5e0!3m2!1sen!2sza!4v1748421826963!5m2!1sen!2sza" >
                </iframe>

            </div>
        </div>
    </div>

    <div class="default-shape">
        <div class="shape-1"><img src="assets/img/shape/1.png" alt="image"></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/2.png" alt="image"></div>
        <div class="shape-3"><img src="assets/img/shape/3.svg" alt="image"></div>
        <div class="shape-4"><img src="assets/img/shape/4.svg" alt="image"></div>
        <div class="shape-5"><img src="assets/img/shape/5.png" alt="image"></div>
    </div>
</section>
